// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"a6e333bd","220":"394ab83d","403":"d00c6dee","484":"c0666ad8","592":"07590af4","608":"c8105291","653":"e98c58a6","744":"1d757441"}[chunkId] + ".chunk.js";
};